module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 118.8V8.44C0 3.78 4.66 0 8.44 0h20.1a8.44 8.44 0 0 1 8.44 8.44V118.8c0 4.66-4.66 8.44-8.44 8.44H8.44A8.44 8.44 0 0 1 0 118.8zM61.16 118.8V8.44C61.16 3.78 65.82 0 69.6 0h20.1a8.44 8.44 0 0 1 8.45 8.44V118.8c0 4.66-4.67 8.44-8.45 8.44H69.6a8.44 8.44 0 0 1-8.44-8.44z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./static/images/pause.svg
// module id = BMTm
// module chunks = 1